import z from 'zod';

export enum UserSoundType {
  CLICK = 'CLICK',
  CHECK = 'CHECK',
  DROPDOWN = 'DROPDOWN',
  SWITCH = 'SWITCH',
  SLIDE = 'SLIDE',
}

export const userSoundTypeSchema = z.enum(UserSoundType);
